
export const COUNTRIES = [
    'Austria',
    'Belgium',
    'Canada',
    'Denmark',
    'Estonia',
    'Finland',
    'France',
    'Germany',
    'Ireland',
    'Italy',
    'Latvia',
    'Lithuania',
    'Netherlands',
    'Norway',
    'Poland',
    'Portugal',
    'Spain',
    'Sweden',
    'United Kingdom (UK)',
    'United States'
];

export const COUNTRIES_CODE = [
  { name: 'Austria', code: 'AT', dial_code: '+43' },
  { name: 'Belgium', code: 'BE', dial_code: '+32' },
  { name: 'Canada', code: 'CA', dial_code: '+1' },
  { name: 'Denmark', code: 'DK', dial_code: '+45' },
  { name: 'Estonia', code: 'EE', dial_code: '+372' },
  { name: 'Finland', code: 'FI', dial_code: '+358' },
  { name: 'France', code: 'FR', dial_code: '+33' },
  { name: 'Germany', code: 'DE', dial_code: '+49' },
  { name: 'Ireland', code: 'IE', dial_code: '+353' },
  { name: 'Italy', code: 'IT', dial_code: '+39' },
  { name: 'Latvia', code: 'LV', dial_code: '+371' },
  { name: 'Lithuania', code: 'LT', dial_code: '+370' },
  { name: 'Netherlands', code: 'NL', dial_code: '+31' },
  { name: 'Norway', code: 'NO', dial_code: '+47' },
  { name: 'Poland', code: 'PL', dial_code: '+48' },
  { name: 'Portugal', code: 'PT', dial_code: '+351' },
  { name: 'Spain', code: 'ES', dial_code: '+34' },
  { name: 'Sweden', code: 'SE', dial_code: '+46' },
  { name: 'United Kingdom (UK)', code: 'GB', dial_code: '+44' },
  { name: 'United States', code: 'US', dial_code: '+1' }
];

